import { useLocation } from "react-router";
import { CITIES } from "../constants";
import { SYSTEMS } from "../permissions";

export const useSystem = () => {
    const location = useLocation()

    const currentSystem = location.pathname.split("/")[2];
    const city_id = currentSystem === "madina" ? CITIES.madina.id : CITIES.makkah.id;

    const from_id = currentSystem === SYSTEMS.MAKKAH.code ? 1 : 2
    const port = currentSystem === SYSTEMS.MAKKAH ? "JED": "MED";

    return { currentSystem, location, city_id, from_id, port };
};